module.exports = __webpack_public_path__ + "static/img/icon-caret.53fda3e6.svg";